import React from 'react';
import {clsx} from 'clsx';
import {twMerge} from 'tailwind-merge';

const Page = React.forwardRef(({className, children}, ref) => {
	return (
		<div
			ref={ref}
			data-ti="page"
			className={twMerge(
				clsx(
					'page',
					'overflow-auto flex flex-col',
					'[&_.page-header]:shrink-0', // Target Header component
					'[&_.page-container]:overflow-auto [&_.page-container]:grow', // Target page container
				),
				className,
			)}
		>
			{children}
		</div>
	);
});

Page.displayName = 'Page';

export default Page;
